import { render } from "./PageCurrent.vue?vue&type=template&id=2fdde3c2"
import script from "./PageCurrent.vue?vue&type=script&lang=js"
export * from "./PageCurrent.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__